export const taxCreditdb = [
    { value: '35F5C55E-8388-4515-86CA-F00E9F738275', label: '35F5C55E-8388-4515-86CA-F00E9F738275', type: '1',
      products: [
        {
          id: 1,
          prodType: { value: 'Producto', label: 'Producto' },
          productCode: '0001',
          productName: 'Arroz',
          quantity: 10,
          unitOfMeasure: { value: 'Metro', label: 'Metro' },
          TypeOfSale: { value: 'Bienes', label: 'Bienes' },
          price: 1500,
          discount: 70,
          accept: true,
          isActive: true,
          subtotal: 6450
        }
      ]
    },
    { value: '36F5C55E-8388-4515-86CA-F00E9F738275', label: '36F5C55E-8388-4515-86CA-F00E9F738275', type: '1',
      products: [
        {
          id: 2,
          prodType: { value: 'Servicio', label: 'Servicio' },
          productCode: '0002',
          productName: 'Consultoría',
          quantity: 5,
          unitOfMeasure: { value: 'Pie', label: 'Pie' },
          TypeOfSale: { value: 'Servicios', label: 'Servicios' },
          price: 200,
          discount: 10,
          accept: false,
          isActive: true
        },
        {
          id: 3,
          prodType: { value: 'Producto', label: 'Producto' },
          productCode: '0003',
          productName: 'Monitor',
          quantity: 20,
          unitOfMeasure: { value: 'Pulgada', label: 'Pulgada' },
          TypeOfSale: { value: 'Bienes', label: 'Bienes' },
          price: 300,
          discount: 50,
          accept: true,
          isActive: true
        }
      ]
     },
    { value: '37F5C55E-8388-4515-86CA-F00E9F738275', label: '37F5C55E-8388-4515-86CA-F00E9F738275', type: '1', products: [
      {
        id: 1,
        prodType: { value: 'Servicio', label: 'Servicio' },
        productCode: '0002',
        productName: 'Consultoría',
        quantity: 5,
        unitOfMeasure: { value: 'Pie', label: 'Pie' },
        TypeOfSale: { value: 'Servicios', label: 'Servicios' },
        price: 200,
        discount: 10,
        accept: false,
        isActive: true
      },
      {
        id: 2,
        prodType: { value: 'Producto', label: 'Producto' },
        productCode: '0003',
        productName: 'Monitor',
        quantity: 20,
        unitOfMeasure: { value: 'Pulgada', label: 'Pulgada' },
        TypeOfSale: { value: 'Bienes', label: 'Bienes' },
        price: 300,
        discount: 50,
        accept: true,
        isActive: true
      }
    ] },
    { value: '38F5C55E-8388-4515-86CA-F00E9F738275', label: '38F5C55E-8388-4515-86CA-F00E9F738275', type: '1', 
      products: [
        {
          id: 1,
          prodType: { value: 'Producto', label: 'Producto' },
          productCode: '0001',
          productName: 'Arroz',
          quantity: 10,
          unitOfMeasure: { value: 'Metro', label: 'Metro' },
          TypeOfSale: { value: 'Bienes', label: 'Bienes' },
          price: 1500,
          discount: 70,
          accept: true,
          isActive: true
        },
        {
          id: 2,
          prodType: { value: 'Servicio', label: 'Servicio' },
          productCode: '0002',
          productName: 'Consultoría',
          quantity: 5,
          unitOfMeasure: { value: 'Pie', label: 'Pie' },
          TypeOfSale: { value: 'Servicios', label: 'Servicios' },
          price: 200,
          discount: 10,
          accept: false,
          isActive: true
        },
        {
          id: 3,
          prodType: { value: 'Producto', label: 'Producto' },
          productCode: '0003',
          productName: 'Monitor',
          quantity: 20,
          unitOfMeasure: { value: 'Pulgada', label: 'Pulgada' },
          TypeOfSale: { value: 'Bienes', label: 'Bienes' },
          price: 300,
          discount: 50,
          accept: true,
          isActive: true
        }
      ]
     },
  ]
  
   